<template>
    <div class="Box">
      <el-card class="box-card">
        <!-- 查询表单 -->
        <el-form :model="queryParams" size="medium" label-width="100px" class="mt35 PUB_search_form">
          <el-row :gutter="12">

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="下载任务ID">
                <el-input v-model="queryParams.id" @change="search" placeholder="请输入下载文件ID" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="数据来源" prop="name">
                <el-select v-model="queryParams.name" filterable @change="search" placeholder="请选择数据来源"
                    style="width: 100%;" clearable>
                    <el-option v-for="dict in typeSelectList" :key="dict.key" :label="dict.name" :value="dict.key" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="下载文件名称">
                <el-input v-model="queryParams.files_name" @change="search" placeholder="请输入下载文件名称" clearable></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="创建时间">
                <el-date-picker
                  v-model="queryParams.created_at"
                  type="datetimerange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="search"
                  style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <el-form-item label="文件状态">
                <el-select v-model="queryParams.status" placeholder="请选择文件状态" clearable class="w100" @change="search">
                  <el-option v-for="dict in statusList" :key="dict.id" :label="dict.name" :value="dict.id" />
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
              <div class="btn_left">
                <el-button type="primary" size="medium" @click="search">查询</el-button>
                <el-button @click="resetQuery" size="medium">重置</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
  
        <!-- 操作按钮 -->
        <div class="div_buttom">
          <div>
            <el-button size="medium" @click="getList('changePage')">刷新列表</el-button>
          </div>
        </div>
  
        <my-table
          ref="myTableRef"
          :table-data="tableData"
          :columns="columns"
          :loading="loading"
          :total="total"
          :page-no="queryParams.pageNo"
          :page-size="queryParams.pageSize"
          @pagination-change="paginationChange"
        >
        
          <template #status="{ scope, value }">
            <el-tag :type="statusMap[scope.row.status]">{{ value }}</el-tag>
          </template>
  
          <template #operation>
            <el-table-column fixed="right" label="操作" min-width="100" align="center">
              <template slot-scope="scope">
                <el-button 
                  :disabled="!(scope.row.status == 2 && scope.row.files)"
                  type="text" size="medium" @click="handleDownload(scope)"
                >下载</el-button>
                <el-button 
                  :disabled="![2,3].includes(scope.row.status)"
                  :class="[ [2,3].includes(scope.row.status) ? 'PUB_BTN_RED' : 'PUB_BTN_DISABLED']" 
                  type="text" size="medium" @click="handleDel(scope.row)"
                >删除</el-button>
              </template>
            </el-table-column>
          </template>
        </my-table>
      </el-card>
    </div>
  </template>
  
  <script>
  import {OperateManageApi} from '@/api/operateManage'
  import { downloadPublic } from '@/utils/util'
  import {processErrors} from "@/utils/errorHandler";
  
  export default {
    components: {
    },  
    data() {
      return {
        api: OperateManageApi(),
        // 查询参数
        queryParams: {
          pageNo: 1,
          pageSize: 10,
          id: '',
          name: '',
          files_name: '',
          created_at: [],
          status: '',
        },
        
        // 表格数据
        tableData: [],
        total: 0,
        loading: false,

        statusList:[
          { id: 0, name: '待生成',},
          { id: 1, name: '文件生成中',},
          { id: 2, name: '已完成',},
          { id: 3, name: '任务失败',},
  
        ],
        // 任务状态 0未开始 1进行中 2已完成 3异常
        statusMap:{
            0: 'info',
            1: '',
            2: 'success',
            3: 'danger',
        },
        typeSelectList: [],
        
        // 表格列配置
        columns: [
          { prop: 'id', checkout: false, label: '下载任务ID', width: 120 },
          { prop: 'name', checkout: false, label: '数据来源', minWidth: 160},
          { prop: 'files_name', checkout: false, label: '下载文件名称', minWidth: 200 },
          { prop: 'status_name', checkout: false, label: '文件状态', minWidth: 100, slotKey: 'status' },
          { prop: 'created_name', checkout: false, label: '下载任务创建人', minWidth: 120 },
          { prop: 'created_at', checkout: false, label: '下载任务创建时间', minWidth: 160 },
        ]
        
      };
    },
    
    created() {
      this.getSelect()
      this.getList(this.queryParams.pageNo != 1 ? 'changePage' : '');
    },
    
    methods: {
      handleDownload(scope) {
        downloadPublic(scope.row.files, scope.row.files_name,'下载成功')
      },
      
      // 查询数据
      search() {
        this.getList();
      },
      
      // 重置查询条件
      resetQuery() {
        this.queryParams = {
          pageNo: 1,
          pageSize: 10,
          id: '',
          name: '',
          files_name: '',
          created_at: [],
          status: '',
        };
        this.getList();
      },
      
      // 获取列表数据
      getList(type) {
        this.loading = true;
        
        if (type !== 'changePage') {
          this.queryParams.pageNo = 1;
        }
  
        this.api.ApiExportList(this.queryParams).then(res=>{
          if(res.code == 0){
            this.tableData =  res.data.data
  
            this.total = res.data.totalCount;
            this.loading = false;
          }
        })
      },
      
      // 分页变化
      paginationChange({ pageNo, pageSize }) {
        this.queryParams.pageNo = pageNo;
        this.queryParams.pageSize = pageSize;
        this.getList('changePage');
      },
      getSelect() {
        this.api.ApiExportTypeSelect().then(res => {
          if (res.code == 0) {
            this.typeSelectList = res.data
          } else {
            processErrors(res);
          }
        })
      },
      handleDel(item){
        this.$confirm('您确定要删除该条下载记录吗？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.api.ApiExportTypeDel({ id: item.id }).then(res => {
            if (res.code == 0) {
              this.$message.success('删除成功！');
              this.getList('changePage');
            } else {
              processErrors(res);
            }
          })
        })
      }
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .btn_left {
    margin-left: 100px;
  }
  .timeNode{
    text-align: left;
    padding-left: 12px;
  }
  .div_buttom {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    justify-content: space-between;
  }
  
  </style>